<template>
  <div class="itemlist">
    <v-card>
      <v-card-title>
        <!-- img src="../../../static/images/icon8icons/icons8-paint-palette-50.png" / -->
        <h1>Naloxone Location Information</h1>
        <v-spacer/>
      </v-card-title>
      <v-card-text>
          <v-layout row class="pb-2">
              <span :class="labelClass">Location ID:</span><span :class="dataClass">{{ newLocation.id }}</span>
              <v-spacer></v-spacer>
              <span :class="labelClass">Last updated:</span><span :class="dataClass">{{ formattedDate }}</span>
          </v-layout>
          <v-layout row class="pb-2">
              <span :class="labelClass">Location Name:</span><span :class="dataClass"> {{newLocation.name }}</span>
          </v-layout>
          <v-layout row class="pb-2">
              <span :class="labelClass">Contact:</span><span :class="dataClass">{{ newLocation.person }} {{formattedPhone}}</span>
          </v-layout>

          <div v-if="newLocation.medicinePresent">
              Medicine is <span :class="dataClass+' success--text'">Present</span>
          </div>
          <div v-else>
              Medicine is <span :class="dataClass+' error--text'">Not present</span>
          </div>
          <v-layout row class="pb-2">
              <span :class="labelClass">Naloxone expires:</span>
                <span :class="dataClass"> {{formattedExpirationDate}} </span>
                <span v-if="expired" :class="'heading-2 error--text pl-2 ' + dataClass ">EXPIRED!</span>
          </v-layout>

          <div>
              <span :class="labelClass">Naloxone available:</span>

              <!-- DayHoursView v-for="(item, index) in items" :key="item"
                 :index="index"
                 v-bind:day="newLocation['days'][index]"
                 v-bind:timeRange="newLocation['timeRanges'][index]">
             </DayHoursView -->

             <DayHoursView  :index="0" v-bind:day="newLocation['days'][0]" v-bind:timeRange="newLocation['timeRanges'][0]"></DayHoursView>
             <DayHoursView  :index="1" v-bind:day="newLocation['days'][1]" v-bind:timeRange="newLocation['timeRanges'][1]"></DayHoursView>
             <DayHoursView  :index="2" v-bind:day="newLocation['days'][2]" v-bind:timeRange="newLocation['timeRanges'][2]"></DayHoursView>
             <DayHoursView  :index="3" v-bind:day="newLocation['days'][3]" v-bind:timeRange="newLocation['timeRanges'][3]"></DayHoursView>
             <DayHoursView  :index="4" v-bind:day="newLocation['days'][4]" v-bind:timeRange="newLocation['timeRanges'][4]"></DayHoursView>
             <DayHoursView  :index="5" v-bind:day="newLocation['days'][5]" v-bind:timeRange="newLocation['timeRanges'][5]"></DayHoursView>
             <DayHoursView  :index="6" v-bind:day="newLocation['days'][6]" v-bind:timeRange="newLocation['timeRanges'][6]"></DayHoursView>

          </div>


          <div>
              <br />
              <span :class="labelClass">Description:</span>
              <v-textarea
                          v-model="newLocation.description"
                          readonly
                          solo
               ></v-textarea>
          </div>
          <MapView :circleRadius="newLocation.radius" :center="{'lat' : newLocation.lat, 'lng':newLocation.lng}" :edittable="false"></MapView>
          <br />

      <v-layout row wrap>
          <v-btn @click="$router.back()"><v-icon>arrow_back</v-icon>Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="deleteLocation"><v-icon>delete</v-icon> Remove Location</v-btn>
          <v-btn @click="editLocation" class="success"><v-icon>edit</v-icon>Edit Location</v-btn>
      </v-layout>
      <div class="error--text" v-if="errMessage != null">
        <v-layout row>
            <v-spacer></v-spacer>{{errMessage}}
        </v-layout>
      </div>
      </v-card-text>
    </v-card>
      <hr />

      <!-- Delete confirmation dialog -->
      <v-dialog v-model="deleteDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">Delete Location</v-card-title>
            <v-card-text>Are you sure you want to delete this location ({{ newLocation.name }})?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" flat @click="deleteDialog = false">Do not delete</v-btn>
              <v-btn color="green darken-1" flat :loading="inProgress" @click="reallyDeleteLocation">Delete it!</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

</div>

</template>

<script>
import {mapState} from 'vuex'
// import firebase from 'firebase/app'

import utils from '../utils.js'

import MapView from '../components/MapView.vue'
import DayHoursView from '../components/DayHoursView.vue'

export default {
  name: 'ViewLocation',
  components: {
      MapView, DayHoursView
  },
  data () {
    return {
        deleteDialog: false,
        inProgress: false,
        getCurrentLocationLoading: false,
        saveInProgress: false,
        valid: false,
        edit: false,
        items: [0,1,2,3,4,5,6],
        newLocation: {
            id: null,
            name: null,
            lastUpdate: 0,
            person: null,
            phone: null,
            medicinePresent: false,
            description: null,
            lat: 0,
            lng: 0,
            timeRanges:[0,1440], // All minutes of the day
            days: [true, true, true, true, true, true, true]
        },
      loading: false,
      errMessage: null,
      labelClass: "pr-2",
      dataClass : "title"

    }
  },
  computed: {
    ...mapState({
      locations: state => state.locations.locations,
      activeLocation: state => state.locations.activeLocation,
    }),
    formattedDate: function () {
        return this.formatDate(this.newLocation.lastUpdate)
    },

    formattedPhone: function () {
        if (this.newLocation.phone &&  this.newLocation.phone.length === 10) {
            let s = `(${this.newLocation.phone.slice(0,3)}) ${this.newLocation.phone.slice(3,6)}-${this.newLocation.phone.slice(6,10)} `
            return s
        } else {
            return "Invalid Phone"
        }
    },
    formattedExpirationDate: function () {
        if (this.newLocation.expirationDate) {
            return (new Date(this.newLocation.expirationDate)).toISOString().substr(0, 10)
        } else {
            return "Missing expiration date!"
        }
    },
    expired: function () {
        if (this.newLocation.expirationDate) {
            return this.newLocation.expirationDate < (new Date()).getTime()
        } else {
            return false
        }
    }

  },
  mounted: function () {
      this.newLocation = this.activeLocation
  },
  methods: {
    formatDate: function (d) {
        return utils.formatDateFromMilliseconds(d)
    },
    editLocation: function () {
      this.$router.push({name: 'AddEditLocation'})
    },
    back: function () {
        this.$router.go(-1)
    },
    deleteLocation: function () {
      this.errMessage = null
      this.deleteDialog = true
    },
    reallyDeleteLocation: async function () {
      try {
          this.inProgress = true
          await utils.deleteLocation(this.newLocation)
          this.$store.commit('locations/setActiveLocation', null)
      } catch (err) {
        this.errMessage = err.message
      }
      this.deleteDialog = false;
      this.inProgress = false
      this.$router.push({name: 'LocManager'})
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.itemlist {
  width: 100%;
}

</style>
